// extracted by mini-css-extract-plugin
module.exports = {"cross":"Cross_cross__XpeM6","openedMenu":"Cross_openedMenu__uHjAq"};